module.exports = __webpack_public_path__ + "media/images/area/feature/kanto/banner/ko-2ebe9936f3d5d67229403a77a4617d83.jpg";